module.exports = __webpack_public_path__ + "img/balance.73a5795e.svg";